import styled from '@emotion/styled';
import { Tooltip, Typography } from '@mui/material';
import { colors } from 'theme/colors';

const StyledTooltip = styled(Tooltip)``;
const StyledMobileTooltip = styled(Typography)`
  background: ${colors.primary900};
  padding: 2px 4px;
  border-radius: 2px;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0%;
  text-align: center;
  color: ${colors.white};
  margin-bottom: 8px;
`;

export { StyledTooltip, StyledMobileTooltip };
